import withFormatHookForm from '../hoc/withFormatHookForm';
import InputFormat from './InputFormat';

const InputFormatWithHookForm = withFormatHookForm(InputFormat);

export default InputFormatWithHookForm;
